import React from 'react';
import AlertWarning from "../../common/alert/AlertWarning";
import {LicenseInfo} from "../../types/LicenseInfo";

const ONTO_MAIL = process.env.REACT_APP_ONTOTEXT_INFO_MAIL;

export default function InvalidLicenseAlert(props: { license?: LicenseInfo }) {
  if (!props.license) {
    return (
      <AlertWarning>
        <p>Couldn't load license</p>
      </AlertWarning>
    );
  }
  return (
    <AlertWarning className="InvalidLicenseAlert">
      <p>
        {props.license.messages}
        <br/>
        Please supply a valid license or contact
        {' '}
        <a href={`mailto:${ONTO_MAIL}`}>Ontotext</a>
        {' '}
        team to acquire one.
      </p>
    </AlertWarning>
  );
}
